// CRM 2.0 · M12 Template Builder · the payment schedule table the system makes (no table in the Word file): the
// columns Legal wants, in her order, with her headings, and whether a Total row goes at the end. The print builds the
// table from the booking's plan: one row per stage, the heading row repeated on each page.
import React, { useState } from "react";
import cls from "./Templates.module.css";

// the columns offered, in the order offered, with a short heading (only the ones in the field list are shown)
const OFFERED = [
  ["plan.stageNo", "Sr. No.", true], ["plan.stageName", "Stage", true], ["plan.percentage", "Percentage (%)", true], ["plan.amount", "Amount (Rs.)", true],
  ["plan.gst", "GST (Rs.)", true], ["plan.total", "Total (Rs.)", true], ["plan.amountWords", "Amount in words", false], ["plan.totalWords", "Total in words", false],
];

function ScheduleTableModal({ fields, item, onSave, onRemove, onCancel }) {
  const known = new Set(fields.map((f) => f.key));
  const start = item
    ? [...item.columns.map((c) => ({ key: c.key, title: String(c.title || "").trim() === "%" ? "Percentage (%)" : c.title, on: true })), ...OFFERED.filter(([k]) => known.has(k) && !item.columns.some((c) => c.key === k)).map(([key, title]) => ({ key, title, on: false }))]
    : OFFERED.filter(([k]) => known.has(k)).map(([key, title, on]) => ({ key, title, on }));
  const [cols, setCols] = useState(start);
  const [totalRow, setTotalRow] = useState(item ? item.totalRow !== false : true);
  const labelOf = (k) => fields.find((f) => f.key === k)?.label || k;
  const move = (i, d) => setCols((list) => { const next = [...list]; const j = i + d; if (j < 0 || j >= next.length) return list; [next[i], next[j]] = [next[j], next[i]]; return next; });
  const ticked = cols.filter((c) => c.on);

  return (
    <div className={cls.mask} role="dialog" aria-modal="true" aria-label="Payment schedule table" onClick={onCancel}>
      <div className={cls.modal} style={{ maxWidth: "60rem" }} onClick={(e) => e.stopPropagation()}>
        <div className={cls.modalHead}><h2>Payment schedule table</h2></div>
        <div className={cls.modalBody}>
          <p className={cls.hint} style={{ marginTop: 0 }}>Tick the columns you want, in the order you want them (↑ ↓). The print makes one row per stage of the booking's own plan.</p>
          {cols.map((c, i) => (
            <div key={c.key} className={cls.colRow}>
              <input type="checkbox" checked={c.on} aria-label={labelOf(c.key)} onChange={(e) => setCols((list) => list.map((x) => (x.key === c.key ? { ...x, on: e.target.checked } : x)))} />
              <input className={cls.optInp} value={c.title} disabled={!c.on} aria-label={`Heading for ${labelOf(c.key)}`}
                onChange={(e) => setCols((list) => list.map((x) => (x.key === c.key ? { ...x, title: e.target.value } : x)))} />
              <span className={cls.hint} style={{ margin: 0, flex: 1 }}>{labelOf(c.key)}</span>
              <button type="button" className={cls.link} disabled={i === 0} onClick={() => move(i, -1)} aria-label="Up">↑</button>
              <button type="button" className={cls.link} disabled={i === cols.length - 1} onClick={() => move(i, 1)} aria-label="Down">↓</button>
            </div>
          ))}
          <label className={cls.chk} style={{ marginTop: "1.2rem" }}>
            <input type="checkbox" checked={totalRow} onChange={(e) => setTotalRow(e.target.checked)} /> Total row at the end (adds up the ticked %, amount, GST, total)
          </label>
          {ticked.length > 0 && (
            <div className={cls.tblw} style={{ marginTop: "1.2rem" }}>
              <table className={cls.tbl}>
                <thead><tr>{ticked.map((c) => <th key={c.key}>{c.title || labelOf(c.key)}</th>)}</tr></thead>
                <tbody>
                  <tr>{ticked.map((c) => <td key={c.key}>{fields.find((f) => f.key === c.key)?.sampleValue || "…"}{c.key === "plan.percentage" ? "%" : ""}</td>)}</tr>
                  {totalRow && <tr>{ticked.map((c, i) => <td key={c.key}><b>{i === ticked.findIndex((x) => !["plan.percentage", "plan.amount", "plan.gst", "plan.total", "plan.amountWords", "plan.totalWords"].includes(x.key)) ? "Total" : ["plan.percentage"].includes(c.key) ? "100%" : ["plan.amount", "plan.gst", "plan.total"].includes(c.key) ? "…" : ""}</b></td>)}</tr>}
                </tbody>
              </table>
            </div>
          )}
        </div>
        <div className={cls.modalFoot}>
          {item && <button className={`${cls.btn} ${cls.danger}`} style={{ marginRight: "auto" }} onClick={onRemove}>Remove the table</button>}
          <button className={cls.btn} onClick={onCancel}>Cancel</button>
          <button className={`${cls.btn} ${cls.primary}`} disabled={!ticked.length}
            onClick={() => onSave({ columns: ticked.map((c) => ({ key: c.key, title: c.title || labelOf(c.key) })), totalRow })}>Save</button>
        </div>
      </div>
    </div>
  );
}

export default ScheduleTableModal;
